import './common.js'
import './home.js'
import './menu.js'
import './responsive-menu.js'
import './presentation.js'
import './contact.js'
import './actualites-offres.js'
import './pole.js'
import './fixed_sidebar.js'
import './filter_map.js'
import './actu.js'
import './search.js'


// WEBPACK FOOTER //
// ./scripts/main.js